// Единый макет для юридических страниц (оферта, политика, обработка данных).
// Соответствует тому же визуальному стилю, что и лендинг: узкая колонка,
// тонкие разделительные линии, типографика Inter.

import { Link, useLocation } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { ReactNode } from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

interface Props {
  title: string;
  updatedAt: string;
  children: ReactNode;
}

const NAV = [
  { to: '/legal/offer', label: 'Оферта' },
  { to: '/legal/privacy', label: 'Политика конфиденциальности' },
  { to: '/legal/data', label: 'Обработка данных' },
];

export default function LegalLayout({ title, updatedAt, children }: Props) {
  const { pathname } = useLocation();

  return (
    <div className="bg-white">
      <Header />

      <main className="section">
        <div className="container-site">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm text-ink/60 hover:text-ink transition"
          >
            <ArrowLeft size={16} strokeWidth={1.75} />
            На главную
          </Link>

          <div className="mt-10 grid gap-12 md:grid-cols-[240px_1fr]">
            {/* Сайдбар-навигация */}
            <aside>
              <div className="text-[11px] font-medium uppercase tracking-[0.14em] text-ink/50">
                Документы
              </div>
              <nav className="mt-5 flex flex-col border-l border-line">
                {NAV.map((item) => {
                  const active = pathname === item.to;
                  return (
                    <Link
                      key={item.to}
                      to={item.to}
                      className={
                        'border-l-2 px-4 py-2 -ml-px text-sm transition ' +
                        (active
                          ? 'border-orange text-ink font-medium'
                          : 'border-transparent text-ink/60 hover:text-ink')
                      }
                    >
                      {item.label}
                    </Link>
                  );
                })}
              </nav>
            </aside>

            {/* Основной контент */}
            <article className="max-w-[68ch]">
              <div className="eyebrow">Правовая информация</div>
              <h1 className="mt-4 text-4xl font-semibold tracking-tightest text-ink sm:text-5xl">
                {title}
              </h1>
              <p className="mt-4 text-sm text-ink/50">Редакция от {updatedAt}</p>

              <div className="legal-content mt-10 text-[15px] leading-relaxed text-ink/80">
                {children}
              </div>
            </article>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
